import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { useAddAvatarToPolotno } from '@/pages/AdvancedEditor/components/panels/avatars/utils/useAddAvatarToPolotno';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, setPageProperty } from '@/pages/AdvancedEditor/hooks';
import { useNormalizePolotnoInitialData } from './useNormalizePolotnoInitialData';

export const useInitFromAvatarPage = () => {
    const { store } = useAdvancedEditorContext();
    const addAvatar = useAddAvatarToPolotno();
    const { normalizeInitialAvatar } = useNormalizePolotnoInitialData();

    const initFromAvatarsPage = async (initialAvatar: any, page: Page) => {
        const normalizedAvatar = normalizeInitialAvatar(initialAvatar);

        await store.history.transaction(async () => {
            setPageProperty(page, PolotnoStoreActivePageKeys.ttsSelectedVoice)(normalizedAvatar.voice || null);
            setPageProperty(page, PolotnoStoreActivePageKeys.ttsIsSelectedDefault)(normalizedAvatar.isSelectedDefault);
            setPageProperty(page, PolotnoStoreActivePageKeys.ttsSelectedLanguage)(normalizedAvatar.language);
        });

        addAvatar(store.activePage, initialAvatar);
    };

    return { initFromAvatarsPage };
};
